import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { Lotes } from '../model/Lotes';
import { FilterUrlService } from './filter-url.service';

@Injectable()
export class LotesService {
  url:string = GLOBAL.url+"lots";
  filter:string;

  constructor( private http:HttpClient, private _urlService:FilterUrlService ) {
    this._urlService.filters.subscribe(new_filter => this.filter = new_filter );
  }
/**
 * Obtiene el listado de 10 lotes.
 * @return listado de lotes o un error.
 */
  public get(){
    let url = this.url;
    return this.http.get(url).map( res => {
        return res;
    });
  }

  /*
  * Obtiene el listado de 1 millon de lotes
  */

  public getAllLotes(){
    return this.http.get(this.url+'?limit=1000000&sort=-code' ).map( res => {
        return res;
    });
  }

  public getDataFiltered(filters){
    let url = this.url+filters;
    return this.http.get(url).map( res => {
        return res;
    });
  }

  /**
  * Obtiene el listado de 5000 lotes.
  * @return listado de lotes o un error.
  */
  public getAll(){
    return this.http.get(this.url+'?limit=1300&sort=-code' ).map( res => {
        return res;
    });
  }

  /**
   * Obtiene el listado de 5000 lotes.
   * @return listado de lotes o un error.
   */
    public getAllSimple(){
      return this.http.get(this.url+'?simple&limit=1300&sort=-code' ).map( res => {
          return res;
      });
    }

/**
* Obtiene el listado de lotes.
* @return listado de lotes o un error.
*/
  public getSomeLotes(code:string){
    return this.http.get(this.url+'?sort=-code&limit=10&code=><'+code ).map( res => {
      return res;
    });
  }

/**
 * Envia un POST para almacenar información.
 * @param  prov información a enviar
 * @return      respuesta de la peticion http
 */
  public save(prov:any){
    return this.http.post(this.url, prov)
      .map( data => {
        return data;
      });
  }

/**
 * Actualiza un elemento en la base de datos
 * @param  url  url del elemento que se actualiza.
 * @param  body ¿?
 * @return      respuesta de la peticion http
 */
  public update(url:string, body){
    return this.http.put(url, body)
      .map( data => {return data;});
  }

/**
 * Elimina un registro de la base de datos
 * @param  url url del elemento que se elimina
 * @return     respuesta de la peticion http
 */
  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });
  }

/**
 * Transforma una fecha (YYYY-MM-DD 00:00:00) para ser almacenada en una BD.
 * @param  fechas fecha a transformar
 * @return        fecha con el formato (YYYY-MM-DD 00:00:00)
 */
  transformDates(fechas:Date,tiempo:Date):String{
    let fecha = moment(fechas);
    let tiempos = moment(tiempo);

    //2018-02-28 00:00:00
    return (fecha.year()+'-'+(fecha.month()+1)+'-'+fecha.date()+' '+tiempos.hour()+':'+tiempos.minutes()+':00');
  }

/**
 * Transforma un objeto a un formato JSON predefinido en el modelo.
 * @param  data Informacion a transformar.
 * @return      Objeto con el formato JSON correcto.
 */
  transformData(data:any){
    let p = new Lotes(
      data['id'],
      data['especie'],
      data['proveedor'],
      data['codigo'],
      this.transformDates(data['fechaextracion'],data['horaextracion']),
      this.transformDates(data['fecharecepcion'],data['horarecepcion']),
      this.transformDates(data['fechaproceso'],data['horaproceso']),
      data['centro'],
      data['guia'],
      data['ret']
    );
    return p.getJson();
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/lotes.service.ts